import moment from 'moment'
require('moment/locale/ru')

export const ruMoment = moment
